export default {
  "pages.layouts.userLayout.title": "OurWork - Foreign Talent Management",
  "pages.login.success": "Login successful",
  "pages.login.failure": "Login failed, please try again",
  "pages.login.username.placeholder": "Username",
  "pages.login.username.required": "Please enter username",
  "pages.login.password.placeholder": "Password",
  "pages.login.password.required": "Please enter password",
  "pages.login.noAccount": "Don't have an account?",
  "pages.login.goRegister": "Register now",
  "pages.register.title": "Register",
  "pages.register.subtitle": "Create your OurWork account",
  "pages.register.success": "Registration successful",
  "pages.register.failure": "Registration failed, please try again",
  "pages.register.username.placeholder": "Username (min 3 characters)",
  "pages.register.username.required": "Please enter username",
  "pages.register.username.min": "Username must be at least 3 characters",
  "pages.register.displayName.placeholder": "Display name (optional)",
  "pages.register.password.placeholder": "Password (min 6 characters)",
  "pages.register.password.required": "Please enter password",
  "pages.register.password.min": "Password must be at least 6 characters",
  "pages.register.confirmPassword.placeholder": "Confirm password",
  "pages.register.confirmPassword.required": "Please confirm password",
  "pages.register.confirmPassword.mismatch": "Passwords do not match",
  "pages.register.submit": "Register",
  "pages.register.hasAccount": "Already have an account?",
  "pages.register.goLogin": "Login",
  "pages.404.subTitle": "Page not found",
  "pages.404.buttonText": "Back to Home",

  // Common
  "pages.common.actions": "Actions",
  "pages.common.edit": "Edit",
  "pages.common.delete": "Delete",
  "pages.common.detail": "Detail",
  "pages.common.save": "Save",
  "pages.common.submit": "Create",
  "pages.common.cancel": "Cancel",
  "pages.common.confirm": "Confirm",
  "pages.common.select": "Please select",
  "pages.common.prev": "Previous",
  "pages.common.next": "Next",
  "pages.common.remark": "Remarks",
  "pages.common.createSuccess": "Created successfully",
  "pages.common.updateSuccess": "Updated successfully",
  "pages.common.deleteSuccess": "Deleted successfully",
  "pages.common.confirmDelete": "Are you sure you want to delete?",
  "pages.common.noData": "No data",

  // Dashboard
  "pages.dashboard.totalCases": "Total Cases",
  "pages.dashboard.activeTasks": "Active Tasks",
  "pages.dashboard.overdueTasks": "Overdue Tasks",
  "pages.dashboard.expiringResidence": "Expiring Residence",
  "pages.dashboard.upcomingTasks": "Upcoming Tasks",
  "pages.dashboard.expiringTalents": "Workers with Expiring Residence",
  "pages.dashboard.noTasks": "No tasks",
  "pages.dashboard.noAlerts": "No alerts",
  "pages.dashboard.calendar": "Calendar",
  "pages.dashboard.calendar.taskDeadline": "Task Deadline",
  "pages.dashboard.calendar.residenceExpiry": "Residence Expiry",
  "pages.dashboard.calendar.eventDue": "Event Due",
  "pages.dashboard.calendar.entryDate": "Entry Date",
  "pages.dashboard.calendar.contractDate": "Contract Date",
  "pages.dashboard.calendar.noEvents": "No events",

  // Case
  "pages.case.caseNumber": "Case Number",
  "pages.case.talentName": "Foreign Worker",
  "pages.case.companyName": "Company",
  "pages.case.status": "Status",
  "pages.case.status.active": "Active",
  "pages.case.status.completed": "Completed",
  "pages.case.status.cancelled": "Cancelled",
  "pages.case.status.suspended": "Suspended",
  "pages.case.progress": "Progress",
  "pages.case.assignee": "Assignee",
  "pages.case.createdAt": "Created",
  "pages.case.create": "New Case",
  "pages.case.residenceStatus": "Residence Status",
  "pages.case.residenceExpiry": "Residence Expiry",
  "pages.case.program": "Program",
  "pages.case.program.technicalIntern": "Technical Intern",
  "pages.case.program.specifiedSkilled": "Specified Skilled",
  "pages.case.program.trainingEmployment": "Training Employment",
  "pages.case.internStage": "Stage",
  "pages.case.internStage.1": "Stage 1",
  "pages.case.internStage.2": "Stage 2",
  "pages.case.internStage.3": "Stage 3",
  "pages.case.practicalStartDate": "Training Start Date",
  "pages.case.fieldCode": "Field",
  "pages.case.fieldCode.construction": "Construction",
  "pages.case.fieldCode.food": "Food Manufacturing",
  "pages.case.fieldCode.nursing": "Nursing Care",
  "pages.case.fieldCode.agriculture": "Agriculture",
  "pages.case.fieldCode.fishing": "Fishing",
  "pages.case.fieldCode.manufacturing": "Manufacturing",
  "pages.case.fieldCode.lodging": "Lodging",
  "pages.case.fieldCode.restaurant": "Restaurant",
  "pages.case.fieldCode.cleaning": "Building Cleaning",
  "pages.case.fieldCode.other": "Other",
  "pages.case.startDate": "Case Start Date",
  "pages.case.endDate": "Case End Date",
  "pages.case.step.talent": "Select Worker",
  "pages.case.step.talent.title": "Please select a worker",
  "pages.case.step.talent.desc":
    "Search and select a worker to associate with the case.",
  "pages.case.step.talent.search": "Search by name or residence card number...",
  "pages.case.step.talent.add": "Add New",
  "pages.case.step.company": "Select Company",
  "pages.case.step.company.title": "Please select a company",
  "pages.case.step.company.desc":
    "Search and select a company to associate with the case.",
  "pages.case.step.company.search":
    "Search by company name or corporate number...",
  "pages.case.step.company.add": "Add New",
  "pages.case.step.details": "Details",
  "pages.case.step.details.title": "Enter case details",
  "pages.case.step.details.desc": "Set program type, field, and other details.",
  "pages.case.tab.info": "Basic Info",
  "pages.case.tab.tasks": "Tasks",
  "pages.case.tab.timeline": "Timeline",
  "pages.case.tab.export": "Export",
  "pages.case.section.caseInfo": "Case Info",
  "pages.case.section.talentInfo": "Worker Info",
  "pages.case.section.companyInfo": "Company Info",
  "pages.case.companyFilter": "Company",
  "pages.case.companyFilter.placeholder": "Select company",
  "pages.case.assigneeFilter": "Assignee",
  "pages.case.assigneeFilter.placeholder": "Select assignee",
  "pages.case.assign": "Assign",
  "pages.case.assignSuccess": "Assignee updated",
  "pages.case.assignError": "Failed to update assignee",
  "pages.case.assignModal.title": "Assign Person",
  "pages.case.assignModal.desc": "Please select an assignee",
  "pages.case.noTasks": "No tasks",
  "pages.case.validate.talentRequired": "Worker is required",
  "pages.case.validate.companyRequired": "Company is required",
  "pages.case.taskCompleted": "Task completed",
  "pages.case.taskCompleteError": "Failed to complete task",
  "pages.case.taskCompleteModal.title": "Complete Task",
  "pages.case.taskCompleteModal.desc":
    "Enter support record ID to complete the task.",
  "pages.case.taskCompleteModal.recordId": "Support Record ID",
  "pages.case.detail.talentNameRomaji": "Name (Romaji)",

  // Talent
  "pages.talent.name": "Name",
  "pages.talent.nameRomaji": "Name (Romaji)",
  "pages.talent.nationality": "Nationality",
  "pages.talent.residenceStatus": "Residence Status",
  "pages.talent.residenceExpiry": "Residence Expiry",
  "pages.talent.residenceCardNo": "Residence Card No.",
  "pages.talent.passportNo": "Passport No.",
  "pages.talent.phone": "Phone",
  "pages.talent.email": "Email",
  "pages.talent.address": "Address",
  "pages.talent.gender": "Gender",
  "pages.talent.birthDate": "Date of Birth",
  "pages.talent.nativeLanguage": "Native Language",
  "pages.talent.create": "Add Worker",
  "pages.talent.edit": "Edit Worker",
  "pages.talent.tab.basic": "Basic Info",
  "pages.talent.tab.emergency": "Emergency Contact",
  "pages.talent.nameKana": "Name (Katakana)",
  "pages.talent.birthPlace": "Place of Birth",
  "pages.talent.homeCountryAddress": "Home Country Address",
  "pages.talent.passportExpiry": "Passport Expiry",
  "pages.talent.visaCategory": "Visa Category",
  "pages.talent.age": "Age",
  "pages.talent.spouseStatus": "Spouse",
  "pages.talent.jobInJapan": "Occupation in Japan",
  "pages.talent.mobilePhone": "Mobile Phone",
  "pages.talent.enrollmentStatus": "Enrollment Status",
  "pages.talent.managedByOtherUnionName": "Other Union Name",
  "pages.talent.difficultyReportDate": "Difficulty Report Date",
  "pages.talent.plannedReturnDate": "Planned Return Date",
  "pages.talent.midtermReturnDate": "Midterm Return / Disappearance Date",
  "pages.talent.trainingRestartDate": "Training Restart Date",
  "pages.talent.transferHistory": "Transfer History",
  "pages.talent.transferDate": "Transfer Date",
  "pages.talent.newSystemFlag": "New System",
  "pages.talent.newSystemStartDate": "New System Start Date",
  "pages.talent.fullReturnDate": "Completion Return Date",
  "pages.talent.traineeCategory": "Trainee Category",
  "pages.talent.status": "Status",
  "pages.talent.identificationCode": "ID Code",
  "pages.talent.photo": "Photo",
  "pages.talent.step.basic": "Basic Info",
  "pages.talent.step.contact": "Contact",
  "pages.talent.step.residence": "Residence & Passport",
  "pages.talent.step.confirm": "Confirm",
  "pages.talent.editDraft": "Edit Worker",
  "pages.talent.saveDraft": "Save Draft",
  "pages.talent.draftSaved": "Draft saved",
  "pages.talent.emergencyName": "Name",
  "pages.talent.emergencyRelation": "Relationship",
  "pages.talent.emergencyPhone": "Phone",
  "pages.talent.tab.training": "Training Info",
  "pages.talent.tab.training.saveSuccess": "Training info saved",

  // Placement Info
  "pages.placement.title": "Training Placement Info",
  "pages.placement.sendingOrg": "Sending Organization",
  "pages.placement.implementingCompany": "Implementing Company",
  "pages.placement.workplaceName": "Workplace Name",
  "pages.placement.workplaceNote":
    "* Fill in if the training location differs from the selected workplace",
  "pages.placement.groupName": "Affiliated Group",
  "pages.placement.accommodationName": "Accommodation",
  "pages.placement.postalCode": "Postal Code",
  "pages.placement.addressLookup": "Lookup Address",
  "pages.placement.addressCandidate": "Address Candidate",
  "pages.placement.address": "Address",
  "pages.placement.occupationTitle": "Training Content",
  "pages.placement.occupationNote": "* Please select all occupations",
  "pages.placement.occupation1": "Transition Occupation 1",
  "pages.placement.occupation2": "Transition Occupation 2 *",
  "pages.placement.occupation3": "Transition Occupation 3 *",
  "pages.placement.occupationOther": "If not a transition occupation",
  "pages.placement.occupationNoTitle": "Trainee Occupation No.",
  "pages.placement.primaryOccupationNo": "Primary Occupation No.",
  "pages.placement.subOccupation1": "Sub Occupation 1",
  "pages.placement.subOccupation2": "Sub Occupation 2",
  "pages.placement.subOccupation3": "Sub Occupation 3",

  // Training Period Info
  "pages.placement.periodTitle": "Training Period Info",
  "pages.placement.homeDepartureDate": "Home Country Departure Date",
  "pages.placement.plannedEntryDate": "Planned Entry Date",
  "pages.placement.actualEntryDate": "Actual Entry Date",
  "pages.placement.phase3StartDate": "Phase 3 Start Date (Entry Date)",
  "pages.placement.tempReturnPeriod": "Temporary Return Period",
  "pages.placement.preEntryTraining": "Pre-Entry Training",
  "pages.placement.preEntryTraining.yes": "Yes",
  "pages.placement.preEntryTraining.no": "No",
  "pages.placement.trainingFacility": "Training Facility",
  "pages.placement.postEntryTrainingPeriod": "Post-Entry Training Period",
  "pages.placement.phase1": "Training Phase 1",
  "pages.placement.phase2": "Training Phase 2",
  "pages.placement.phase3": "Training Phase 3",
  "pages.placement.approvalDate": "Approval Date",
  "pages.placement.approvalNumber": "Approval Number",
  "pages.placement.trainingPeriod": "Training Period",
  "pages.placement.phaseRemark": "Remarks / Notes",
  "pages.placement.hasFixedContract": "Fixed-term Contract",
  "pages.placement.hasFixedContract.yes": "Yes",
  "pages.placement.hasFixedContract.no": "No",
  "pages.placement.contractPeriod": "Contract Period",
  "pages.placement.subCategory": "Trainee Category",
  "pages.placement.enrollmentStatus": "Status",
  "pages.placement.categoryStatus": "Category & Status",

  // Tabs
  "pages.talent.tab.visa": "Visa & Residence",
  "pages.talent.tab.employer": "Employer Info",
  "pages.talent.tab.support": "Support Records",

  // Company
  "pages.company.name": "Company Name",
  "pages.company.corporateNumber": "Corporate Number",
  "pages.company.representative": "Representative",
  "pages.company.industry": "Industry",
  "pages.company.contact": "Contact",
  "pages.company.contactName": "Contact Name",
  "pages.company.contactPhone": "Phone",
  "pages.company.contactEmail": "Email",
  "pages.company.address": "Address",
  "pages.company.create": "Add Company",
  "pages.company.edit": "Edit Company",
  "pages.company.detail": "Company Detail",

  // Task
  "pages.task.name": "Task Name",
  "pages.task.type": "Type",
  "pages.task.dueDate": "Due Date",
  "pages.task.status": "Status",
  "pages.task.status.pending": "Pending",
  "pages.task.status.inProgress": "In Progress",
  "pages.task.status.done": "Done",
  "pages.task.status.overdue": "Overdue",
  "pages.task.markDone": "Done",
  "pages.task.caseNumber": "Case Number",
  "pages.task.stat.total": "Total",
  "pages.task.stat.pending": "Pending",
  "pages.task.stat.overdue": "Overdue",
  "pages.task.stat.completed": "Completed",
  "pages.task.taskName": "Task Name",
  "pages.task.taskType": "Type",
  "pages.task.type.guidance": "Pre-arrival Guidance",
  "pages.task.type.interview": "Periodic Interview",
  "pages.task.type.lifeSupport": "Life Support",
  "pages.task.type.document": "Document Submission",
  "pages.task.type.other": "Other",
  "pages.task.status.skipped": "Skipped",
  "pages.task.completedAt": "Completed At",
  "pages.task.confirmDone": "Mark this task as done?",
  "pages.task.doneSuccess": "Task completed",

  // Support Record
  "pages.record.caseId": "Case",
  "pages.record.case": "Case",
  "pages.record.conductedDate": "Conducted Date",
  "pages.record.content": "Content",
  "pages.record.remark": "Remarks",
  "pages.record.createdAt": "Created",
  "pages.record.create": "New Record",
  "pages.record.edit": "Edit Record",

  // Residence
  "pages.residence.expired": "Expired",
  "pages.residence.within30": "Within 30 days",
  "pages.residence.within60": "Within 60 days",
  "pages.residence.within90": "Within 90 days",
  "pages.residence.noAlerts": "None",
  "pages.residence.talentId": "Foreign Worker",
  "pages.residence.currentExpiry": "Current Expiry",
  "pages.residence.newExpiry": "New Expiry",
  "pages.residence.applicationDate": "Application Date",
  "pages.residence.status": "Status",
  "pages.residence.status.pending": "Not Applied",
  "pages.residence.status.submitted": "Submitted",
  "pages.residence.status.approved": "Approved",
  "pages.residence.status.rejected": "Rejected",
  "pages.residence.receiptNumber": "Receipt Number",
  "pages.residence.create": "Add Record",
  "pages.residence.edit": "Edit Record",

  // Document
  "pages.document.fileName": "File Name",
  "pages.document.category": "Category",
  "pages.document.category.general": "General",
  "pages.document.category.contract": "Contract",
  "pages.document.category.residence": "Residence",
  "pages.document.category.certificate": "Certificate",
  "pages.document.fileSize": "Size",
  "pages.document.createdAt": "Upload Date",
  "pages.document.upload": "Upload",
  "pages.document.download": "Download",
  "pages.document.uploadSuccess": "Uploaded successfully",
  "pages.document.uploadError": "Upload failed",
  "pages.document.downloadError": "Download failed",
  "pages.document.tab.uploadTitle": "Upload Document",
  "pages.document.tab.file": "File",
  "pages.document.tab.selectFile": "Select File",
  "pages.document.category.application": "Application",
  "pages.document.category.notification": "Notification",
  "pages.document.category.notice": "Notice",
  "pages.document.category.photo": "Photo",
  "pages.document.category.other": "Other",
  "pages.talent.tab.documents": "Documents",

  // Event
  "pages.event.eventNumber": "Event Number",
  "pages.event.eventType": "Type",
  "pages.event.type.correction": "Correction",
  "pages.event.type.incident": "Incident",
  "pages.event.type.complaint": "Complaint",
  "pages.event.type.other": "Other",
  "pages.event.summary": "Summary",
  "pages.event.resolution": "Resolution",
  "pages.event.status": "Status",
  "pages.event.status.open": "Open",
  "pages.event.status.inProgress": "In Progress",
  "pages.event.status.resolved": "Resolved",
  "pages.event.status.closed": "Closed",
  "pages.event.occurredDate": "Occurred Date",
  "pages.event.dueDate": "Due Date",
  "pages.event.caseId": "Case ID",
  "pages.event.create": "New Event",
  "pages.event.edit": "Edit Event",

  // Export
  "pages.export.jobNumber": "Job Number",
  "pages.export.exportType": "Type",
  "pages.export.type.casePack": "Case Evidence Pack",
  "pages.export.type.periodPack": "Period Report Pack",
  "pages.export.status": "Status",
  "pages.export.createdAt": "Created",
  "pages.export.finishedAt": "Finished",
  "pages.export.download": "Download",
  "pages.export.downloadError": "Download failed",
  "pages.export.casePack": "Case Evidence Pack",
  "pages.export.periodPack": "Period Report Pack",
  "pages.export.caseId": "Case ID",
  "pages.export.startDate": "Start Date",
  "pages.export.endDate": "End Date",
  "pages.export.createSuccess": "Export job created",

  // Plan
  "pages.plan.planName": "Plan Name",
  "pages.plan.status": "Status",
  "pages.plan.currentPeriodEnd": "Next Renewal",
  "pages.plan.caseUsage": "Cases",
  "pages.plan.userUsage": "Users",
  "pages.plan.storageUsage": "Storage",
  "pages.plan.upgrade": "Upgrade Plan",
  "pages.plan.paymentHistory": "Payment History",
  "pages.plan.upgradeSuccess": "Upgraded successfully",
  "pages.plan.upgradeError": "Upgrade failed",
  "pages.plan.free": "Free",
  "pages.plan.currentPlan": "Current Plan",
  "pages.plan.selectPlan": "Select This Plan",
  "pages.plan.caseLimit": "Case Limit",
  "pages.plan.userLimit": "User Limit",
  "pages.plan.storageLimit": "Storage",

  // Payment
  "pages.payment.paidAt": "Paid At",
  "pages.payment.description": "Description",
  "pages.payment.amount": "Amount",
  "pages.payment.status": "Status",
  "pages.payment.status.paid": "Paid",
  "pages.payment.status.pending": "Pending",
  "pages.payment.status.failed": "Failed",
  "pages.payment.invoice": "Invoice",
  "pages.payment.viewInvoice": "View Invoice",

  // Settings
  "pages.settings.tab.profile": "Profile",
  "pages.settings.tab.password": "Change Password",
  "pages.settings.tab.orgInfo": "Organization Info",
  "pages.settings.tab.members": "Member Management",
  "pages.settings.username": "Username",
  "pages.settings.email": "Email",
  "pages.settings.nickname": "Display Name",
  "pages.settings.phone": "Phone",
  "pages.settings.profileUpdated": "Profile updated",
  "pages.settings.oldPassword": "Current Password",
  "pages.settings.newPassword": "New Password",
  "pages.settings.confirmPassword": "Confirm Password",
  "pages.settings.changePassword": "Change Password",
  "pages.settings.passwordChanged": "Password changed",
  "pages.settings.passwordMismatch": "Passwords do not match",
  "pages.settings.teamSettings": "Team Management",
  "pages.settings.orgName": "Organization Name",
  "pages.settings.legalName": "Legal Name",
  "pages.settings.address": "Address",
  "pages.settings.memberName": "Name",
  "pages.settings.memberEmail": "Email",
  "pages.settings.memberRole": "Role",
  "pages.settings.memberStatus": "Status",
  "pages.settings.status.active": "Active",
  "pages.settings.status.invited": "Invited",
  "pages.settings.status.disabled": "Disabled",
  "pages.settings.inviteMember": "Invite Member",
  "pages.settings.inviteEmail": "Email Address",
  "pages.settings.inviteRole": "Role",
  "pages.settings.inviteSuccess": "Invitation sent",
  "pages.settings.removeMember": "Remove",
  "pages.settings.confirmRemove": "Remove this member?",
  "pages.settings.credentialModal.title": "Account Created",
  "pages.settings.credentialModal.desc":
    "Please share the following login credentials with the member. They will be prompted to change the password on first login.",
  "pages.settings.credentialModal.username": "Username (Email)",
  "pages.settings.credentialModal.password": "Temporary Password",

  // Change Initial Password
  "changeInitialPassword.title": "Change Password",
  "changeInitialPassword.hint":
    "For security, please change your password on first login",
  "changeInitialPassword.new": "New Password",
  "changeInitialPassword.confirm": "Confirm Password",
  "changeInitialPassword.submit": "Change Password",
  "changeInitialPassword.skip": "Skip for now",
  "changeInitialPassword.success": "Password changed successfully",
  "settings.password.minLength": "Password must be at least 6 characters",

  // Page Titles
  "pages.login.title": "Login",
  "pages.dashboard.title": "Dashboard",
  "pages.case.list": "Case List",
  "pages.case.detail": "Case Detail",
  "pages.talent.list": "Worker List",
  "pages.company.list": "Company List",
  "pages.task.list": "Task List",
  "pages.task.create": "Create Task",
  "pages.task.createSuccess": "Task created successfully",
  "pages.record.guidanceTitle": "Pre-arrival Guidance",
  "pages.record.interviewTitle": "Periodic Interview",
  "pages.record.lifeSupportTitle": "Life Support Records",
  "pages.residence.alertTitle": "Expiry Alert",
  "pages.residence.historyTitle": "Renewal History",
  "pages.document.list": "Document List",
  "pages.event.list": "Event List",
  "pages.export.list": "Export List",
  "pages.settings.title": "Settings",
  "pages.plan.upgradeTitle": "Upgrade Plan",

  // Feedback
  "feedback.title": "Feedback",
  "feedback.tooltip": "Feedback",
  "feedback.submit": "Submit",
  "feedback.submitSuccess": "Feedback submitted successfully",
  "feedback.submitError": "Failed to submit feedback",
  "feedback.category": "Category",
  "feedback.category.bug": "Bug Report",
  "feedback.category.feature": "Feature Request",
  "feedback.category.suggestion": "Suggestion",
  "feedback.content": "Content",
  "feedback.contentRequired": "Please enter your feedback",
  "feedback.contactEmail": "Contact Email (optional)",
  "feedback.emailInvalid": "Invalid email format",
};
